import { take, call, select, put, fork, race, delay } from 'redux-saga/effects';
import { getCf } from '../../../services/centrifugo';
import { getAnalytics, initAnalytics } from '../../../services/analytics';
import { SET_CENTRIFUGO_CONNECTED } from '../../constants/centrifugo';
import { setAnalyticsConnected } from '../../actions/domain/analytics/state';
import {
  brandSelector,
  languageSelector,
  channelSelector,
} from '../../reducers/app/params';
import { growthbookExperimentsSelector } from '../../reducers/app/growthbookExperiments';
import {
  addContextToAnalytics,
  buildGrowthbookContext,
} from '../../../utils/analytics';
import { ADD_GROWTHBOOK_EXPERIMENT } from '../../constants/growthbookExperiments';
import {
  SET_PARAM_CROSS_DOMAIN_CLICK_STREAM_ID,
  getParamCrossDomainClickStreamId,
} from '@corefront/redux-aba';
import { GROWTHBOOK_LOADED } from '../../constants/experiment';
import { getGrowthBook } from '../../../services/growthbook';
import FEATURES, { DEFAULT_VALUES } from '../../../constants/featureToggling';

export const GET_PARAMS_TIMEOUT = 50;

export function* getCrossDomainId() {
  yield take(GROWTHBOOK_LOADED);

  const isCrossDomainClickstreamIdEnabled = getGrowthBook()?.getFeatureValue(
    FEATURES.CROSS_DOMAIN_CLICKSTREAM_ID,
    DEFAULT_VALUES.CROSS_DOMAIN_CLICKSTREAM_ID
  );

  if (isCrossDomainClickstreamIdEnabled) {
    yield put(getParamCrossDomainClickStreamId());
  }

  return yield race({
    action: take(SET_PARAM_CROSS_DOMAIN_CLICK_STREAM_ID),
    timeout: delay(GET_PARAMS_TIMEOUT),
  });
}

export function* analyticsWatcher() {
  const { action, timeout } = yield call(getCrossDomainId);
  const crossDomainId = action?.payload;
  yield take(SET_CENTRIFUGO_CONNECTED);
  const cf = yield call(getCf);
  const brand = yield select(brandSelector);
  const language = yield select(languageSelector);
  const channel = yield select(channelSelector);

  yield call(
    initAnalytics,
    cf,
    {
      brand,
      language,
      channel,
    },
    !timeout && crossDomainId
  );
  yield fork(handleAdditionalAnalyticsContext);
  yield put(setAnalyticsConnected());
}

export function* handleAdditionalAnalyticsContext() {
  const analytics = yield call(getAnalytics);
  const experiments = yield select(growthbookExperimentsSelector);

  addContextToAnalytics(analytics, experiments.map(buildGrowthbookContext));

  while (true) {
    const { payload } = yield take([ADD_GROWTHBOOK_EXPERIMENT]);
    addContextToAnalytics(analytics, [buildGrowthbookContext(payload)]);
  }
}
